import camelcaseKeys from 'camelcase-keys';

import { type CollectionItem } from 'api/types/CollectionItem';
import { type RawCollectionItem } from 'api/types/CollectionItem/RawCollectionItem';

export const parseCollectionItemData = (rawData: RawCollectionItem) => {
  const data = camelcaseKeys({ ...rawData }, { deep: true });

  return {
    id: data.fileId,
    image: data.image,
    pageId: data.pageId,
    title: data.title,
    type: data.type,
    url: data.type === 'pdf' ? `https://stack.travpromobile.com/viewer.php?file=${data.url}#zoom=page-fit` : data.url,
  } as CollectionItem;
};
